"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMPLIANCE_TRACKING = exports.COMPETITOR_ANALYSIS = exports.COMPETITIVE_ANALYSIS = exports.COMMENTS = exports.COLLABORATIVE_PROJECT_PLANNING = exports.COLLABORATION = exports.CLOSED_CAPTIONS = exports.CLICK_TO_CALL = exports.CLEANSE_STANDARDIZE_DATA = exports.CHAT_ROUTING = exports.CHAT_RATING = exports.CHAT_MONITORING = exports.CHANNEL_ATTRIBUTION = exports.CENTRAL_DATABASE = exports.CATALOGING_CATEGORIZATION = exports.CANNED_RESPONSES = exports.CAMPAIGN_PERSONALIZATION = exports.CAMPAIGN_MANAGEMENT = exports.CAMPAIGN_INSIGHTS = exports.CALLBACK_SCHEDULING = exports.CALL_SUMMARY_NOTES = exports.CALL_SHARING = exports.CALL_SCRIPTING = exports.CALL_ROUTING = exports.CALL_RECORDING_PLAYBACK = exports.CALL_LOGGING = exports.CALL_BARGING = exports.CALENDARS = exports.CALENDAR_VIEW = exports.CALENDAR_REMINDER_SYSTEM = exports.CALENDAR_MANAGEMENT = exports.BUSINESS_PROCESS_AUTOMATION = exports.BULK_UPLOADING = exports.BULK_UPDATES = exports.BULK_EMAIL_SENDING = exports.BUILDING_PERSONALIZING_EMAILS = exports.BUILDING_AND_PERSONALIZING_EMAILS = exports.BUDGETING_FORECASTING = exports.BUDGET_MANAGEMENT = exports.BRANDING = exports.BRAND_TRACKING = exports.BRAND_OVERLAY = exports.BRAND_OPTIMIZATION = exports.BRAND_ALERTS = exports.BOX_OFFICE_MANAGEMENT = exports.BLOGGING = exports.BLENDED_CALL_CENTER = exports.BILLING_INVOICING = exports.BID_MANAGEMENT = exports.BENEFITS_MANAGEMENT = exports.BASELINING_KPIS = exports.BARCODE_TICKET_SCANNING = exports.BADGE_MANAGEMENT = exports.AUTORESPONDERS = exports.AUTOMATION_TOOLS = exports.AUTOMATION = exports.AUTOMATIC_CALL_DISTRIBUTORS = exports.AUTOMATED_SCHEDULING = exports.AUTOMATED_ROUTING = exports.AUTOMATED_PUBLISHING = exports.AUTOMATED_EMAIL_RESPONSES = exports.AUTO_UPDATE = exports.AUTO_TAX_PAYMENTS = exports.AUDITING = exports.AUDIT_TRAIL = exports.ATTRIBUTION_REPORTING = exports.ATTENDEE_REPORTS = exports.ATTENDEE_NETWORKING = exports.ATTENDEE_MANAGEMENT = exports.ASSET_MANAGEMENT = exports.ARCHIVING = exports.APPROVAL_PROCESS = exports.APPOINTMENT_SETTING = exports.APPOINTMENT_SCHEDULING = exports.ANSWER_SCORING = exports.ANSWER_FLOWS = exports.ANNOTATION = exports.ANALYTICS_ROI_TRACKING = exports.ANALYTICS = exports.ALERTS_NOTIFICATIONS = exports.ALERTS_ESCALATION = exports.ALERTS = exports.AGILE_METHODOLOGIES = exports.AGILE_AT_SCALE_ADVANCED_WORKFLOW_ENGINE = exports.ADVERTISING = exports.ADVANCED_SEARCH = exports.ADVANCED_DOCUMENT_MANAGEMENT = exports.ADD_ONS = exports.ACTIVITY_STREAM_AT_MENTION = exports.ACTIVITIES = exports.ACCOUNTS_RECEIVABLE = exports.ACCOUNTS_PAYABLE = exports.ACCOUNTING_INTEGRATION = exports.ACCOUNT_INTELLIGENCE = exports.ACCOUNT_IDENTIFICATION = exports.ACCOUNT_BASED_ENGAGEMENT = exports.ACCOUNT_ALERTS = exports.ACCESSIBILITY_ACCESS_PERMISSIONS = exports.ACCESS_CONTROLS_PERMISSIONS = exports.A_B_TESTING = void 0;
exports.FILE_TRANSFERS = exports.FILE_TRANSFER = exports.FILE_SHARING = exports.FACILITY_SCHEDULING = exports.EXTRACT_TRANSFER_LOAD = exports.EXPERTISE_LOCATION = exports.EXPENSE_MANAGEMENT = exports.EXHIBIT_VENDOR_MANAGEMENT = exports.EVENT_WEBSITE_CREATION = exports.EVENT_TRIGGERED_EMAIL = exports.EVENT_REPORTING = exports.EVENT_MARKETING = exports.EVENT_MANAGEMENT = exports.EVENT_CREATION = exports.ETL = exports.ESCALATION_MANAGEMENT = exports.ENTERPRISE_SCALABILITY = exports.ENGAGEMENT_MONITORING = exports.EMPLOYEE_SCHEDULING = exports.EMAIL_TRACKING = exports.EMAIL_TO_CASE = exports.EMAIL_MOBILE_PREVIEW = exports.EMAIL_MARKETING = exports.EMAIL_INTEGRATIONS = exports.EMAIL_INTEGRATION = exports.EMAIL_CUSTOMIZATION = exports.EMAIL_AUTOMATION = exports.EFFICIENT_WORKLOAD_PERFORMANCE_MANAGEMENT = exports.EFFECTIVE_TIME_TRACKING = exports.EFFECTIVE_REPORTING_ANALYTICS = exports.ECOMMERCE = exports.EASY_INTEGRATIONS = exports.EASY_ADMINISTRATION = exports.E_COMMERCE = exports.DYNAMIC_CONTENT = exports.DUE_DATES = exports.DRIP_CAMPAIGNS = exports.DRAG_DROP = exports.DOMAIN_NAME = exports.DOCUMENT_STORAGE = exports.DOCUMENT_MANAGEMENT = exports.DISPOSITION_CODES = exports.DISCUSSION_BOARDS = exports.DIRECT_DEPOSIT = exports.DEPENDENCIES = exports.DELIVERY = exports.DECISION_TREE = exports.DEAL_MANAGEMENT_PROMOTIONS = exports.DATABASE_MANAGEMENT = exports.DATA_VISUALIZATION = exports.DATA_MIGRATION = exports.DATA_IMPORT_EXPORT_TOOLS = exports.DATA_IMPORT_EXPORT = exports.DATA_FORMATING = exports.DATA_COLLECTION = exports.DATA_ANALYSIS_TOOLS = exports.DASHBOARDS = exports.DASHBOARD = exports.CUSTOMIZATION = exports.CUSTOMIZABLE_TEMPLATES = exports.CUSTOMIZABLE_DASHBOARD = exports.CUSTOMIZABLE_BRANDING = exports.CUSTOMER_SEGMENTATION = exports.CUSTOMER_SCHEDULING = exports.CUSTOMER_SATISFACTION_SURVEY = exports.CUSTOMER_PROFILES = exports.CUSTOMER_PROFILE_INTERVIEW = exports.CUSTOMER_PORTAL = exports.CUSTOMER_JOURNEY_MAPPING = exports.CUSTOMER_ENGAGEMENT = exports.CUSTOMER_DATABASE = exports.CUSTOMER_ANALYTICS_SEGMENTATION = exports.CUSTOM_SURVEY_URLS = exports.CUSTOM_REPORTING = exports.CROSS_CHANNEL_FULFILLMENT = exports.CRM_LEAD_INTEGRATION = exports.CRM_INTEGRATION = exports.CRM = exports.CORE_HR_INTEGRATION = exports.CONVERSIONS = exports.CONVERSION_TRACKING = exports.CONVERSATION_ARCHIVING = exports.CONTROLLED_TELEPHONY = exports.CONTENT_TAXONOMY = exports.CONTENT_REPOSITORY = exports.CONTENT_QUEUE = exports.CONTENT_MANAGEMENT = exports.CONTENT_IMPORT_EXPORT = exports.CONTENT_CREATION = exports.CONTENT_AUTHORING = exports.CONTENT_AGGREGATION = exports.CONTACT_MANAGEMENT = exports.CONTACT_LIST_MANAGEMENT = exports.CONTACT_IMPORT_EXPORT = exports.CONTACT_DISCOVERY = exports.CONTACT_DATABASE_MANAGEMENT = exports.CONTACT_ACCOUNT_MANAGEMENT = exports.CONFERENCES_CONVENTIONS = exports.CONCESSIONS_MANAGEMENT = exports.COMPUTER_TELEPHONY_INTEGRATION = void 0;
exports.MULTIPLE_DATA_SOURCES = exports.MULTIMEDIA_SUPPORT = exports.MULTILINGUAL_SUPPORT = exports.MULTI_USER_COLLABORATION = exports.MULTI_LOCATION = exports.MULTI_HOSTS = exports.MULTI_CHANNEL_COMMUNICATION = exports.MULTI_ACCOUNT_MANAGEMENT = exports.MOBILE_TICKETING = exports.MOBILE_SURVEY = exports.MOBILE_SUPPORT = exports.MOBILE_SEARCH_TRACKING = exports.MOBILE_SCREEN_SUPPORT = exports.MOBILE_PRESENTATION = exports.MOBILE_OPTIONS = exports.MOBILE_OPTIMIZATION = exports.MOBILE_CHECK_IN = exports.MOBILE_APP = exports.MOBILE_ACCESS = exports.MOBILE = exports.MILESTONE_TRACKING = exports.METADATA_MANAGEMENT = exports.MERGE_DUPLICATES = exports.MEMBERSHIP = exports.MEETING_MANAGEMENT = exports.MEDIA = exports.MARKETING_LEAD_DATABASE = exports.MARKETING_AUTOMATION_INTEGRATION = exports.MANUFACTURING = exports.MANUAL_DIALER = exports.MAKE_RECEIVE_RECORD_CALLS = exports.MAILING_LIST_MANAGEMENT = exports.LOCALIZATION = exports.LIVE_PRESENTATION = exports.LIVE_CHAT = exports.LINK_SHARING = exports.LINK_MANAGEMENT = exports.LEAVE_TRACKING = exports.LEAD_SEGMENTATION = exports.LEAD_SCORING = exports.LEAD_NURTURING = exports.LEAD_MANAGEMENT = exports.LEAD_GENERATION_RETRIEVAL = exports.LEAD_DEVELOPMENT = exports.LEAD_DATABASE_INTEGRATION = exports.LEAD_CAPTURE = exports.LEAD_ANAYSIS = exports.LANDING_PAGES_WEB_FORMS = exports.KPI_BASED_REPORTS = exports.KNOWLEDGE_BASE_MANAGEMENT = exports.KNOWLEDGE_BASE = exports.KIOSK_TICKETING = exports.KEYWORD_TRACKING = exports.KEYWORD_RESEARCH = exports.KEYWORD_ANALYSIS = exports.JOURNAL_ENTRIES = exports.IVR_VOICE_RECOGNITION = exports.IT_ASSET_MANAGEMENT = exports.INVOICE_CUSTOMIZATION = exports.INVENTORY_REPORTING = exports.INVENTORY_MANAGEMENT = exports.INTERNAL_CHAT_INTEGRATION = exports.INTERACTIVE_VOICE_RESPONSES = exports.INTERACTIVE_VOICE_RESPONSE = exports.INTERACTION_TRACKING = exports.INTEGRATIONS = exports.INTEGRATION_APIS = exports.INTEGRATION = exports.INSTANT_RETRIEVAL = exports.INSIGHTFUL_VIEWS = exports.INBOUND_CALL_CENTER = exports.IN_APP_MESSAGING = exports.IMAGE_GALLERY = exports.IDEAL_CUSTOMER_PROFILE = exports.IDEA_MANAGEMENT = exports.HTML_INPUT = exports.HR_MANAGEMENT = exports.HOSTING = exports.HOME_PRINTING = exports.HIGH_VOLUME_SENDING = exports.HELP_DESK = exports.GROUP_SCHEDULING = exports.GRAPHICAL_WORKFLOW_EDITOR = exports.GOALS_QUOTA_MANAGEMENT = exports.GEO_TARGETING = exports.GENERAL_ADMISSION = exports.GANTT_CHARTS = exports.GAMIFICATION = exports.GALLERIES = exports.FUNDRAISING_MANAGEMENT = exports.FUND_ACCOUNTING = exports.FULL_TEXT_SEARCH = exports.FORUMS = exports.FORMS_MANAGEMENT = exports.FORMS = exports.FORECASTING = exports.FLOWS = exports.FIRMOGRAPHIC = exports.FINANCIAL_MANAGEMENT = exports.FILE_VIEWING = void 0;
exports.SELF_SERVICE_PORTAL = exports.SEGMENTATION = exports.SECURITY = exports.SEASON_TICKETS = exports.SEARCHABLE = exports.SEARCH_MARKETING = exports.SEARCH_FUNCTION = exports.SEARCH_ENGINE_SUBMISSION = exports.SCREENSHARE = exports.SCREEN_SHARING = exports.SCREEN_ACTIVITY_RECORDING = exports.SCHEDULED_RECORDING = exports.SCALABILITY = exports.SALES_MARKETING = exports.SALES_INTELLIGENCE = exports.ROOM_BOOKING_MANAGEMENT = exports.ROLE_BASED_ACCESS_CONTROL = exports.ROLE_BASED_ACCESS = exports.REVIEWS_MANAGEMENT = exports.REVENUE_MANAGEMENT = exports.RETURNS_MANAGEMENT = exports.RESPONSE_MANAGEMENT = exports.RESPONSE_AUTOMATION = exports.RESOURCE_SCHEDULING = exports.RESOURCE_MANAGEMENT = exports.RESERVED_SEATING = exports.REPORTS_DASHBOARDS = exports.REPORTS_ANALYTICS = exports.REPORTING_EVENT_ANALYTICS = exports.REPORTING_DASHBOARDS = exports.REPORTING_ANALYTICS = exports.REPORTING = exports.REGULATORY_COMPLIANCE = exports.REGISTRATION_MANAGEMENT = exports.REGISTRATION = exports.RECORDING_BOOKMARKING = exports.RECORDING = exports.RECORD_KEEPING = exports.REAL_TIME_SCHEDULING = exports.REAL_TIME_EDITING = exports.REAL_TIME_CHAT = exports.RANK_TRACKING = exports.QUEUE_TIMES = exports.QUEUE_MANAGEMENT = exports.QUESTION_LIBRARY = exports.QUESTION_CONDITIONS = exports.Q_A = exports.PURCHASING = exports.PURCHASE_ORDERS = exports.PUBLIC_PRIVATE = exports.PROSPECTING_TOOLS = exports.PROPOSAL_MANAGEMENT = exports.PROJECT_TRACKING = exports.PROJECT_TAGS_FOLDERS = exports.PROJECT_MANAGEMENT_WITH_BOARDS = exports.PROGRESSIVE_PROFILING = exports.PROGRESSIVE_DIALER = exports.PROGRESS_TRACKING = exports.PRODUCT_VISUALIZATION = exports.PROACTIVE_CHAT = exports.PRIVACY_OPTIONS = exports.PRESENTATION_MANAGEMENT = exports.PREDICTIVE_DIALER = exports.PREDICTIVE_ANALYTICS = exports.PRE_BUILT_TEMPLATES = exports.POST_SCHEDULING = exports.POS = exports.PORTFOLIO_MANAGEMENT = exports.POP_UP_CHAT = exports.POLLS_VOTING = exports.POINTS_OF_CONTACT = exports.PLUGINS = exports.PLATFORM_INTEGRATION = exports.PIPELINE_MANAGEMENT = exports.PERSONALIZATION = exports.PERFORMANCE_MANAGEMENT = exports.PAYROLL_ENTRY = exports.PAYMENT_PROCESSING = exports.PAGE_MANAGEMENT = exports.OUTBOUND_CALL_CENTER = exports.ORDER_MANAGEMENT = exports.OPPORTUNITY_PIPELINE_MANAGEMENT = exports.OPERATOR_MONITORING = exports.OPEN_API = exports.ONSITE_TICKETING = exports.ONSITE_MANAGEMENT = exports.ONLINE_TICKETING = exports.ONLINE_STORE_BUILDER = exports.ONLINE_PAYMENT_ACCEPTANCE = exports.ONLINE_EVENT_REGISTRATION = exports.ONLINE_BOOKING_TOOLS = exports.ONLINE_BOOKING = exports.ONLINE_BEHAVIOR_TRACKING = exports.ON_SITE_EVENT_MANAGEMENT = exports.OFFLINE_RESPONSE_COLLECTION = exports.OFFLINE_FORM = exports.NOTIFICATIONS = exports.NONPROFITS = exports.NEWSLETTERS = exports.NETWORK_MONITORING = void 0;
exports.WYSIWYG_FORM_DESIGNER = exports.WORKFLOW_CONFIGURATION = exports.WORKFLOW_AUTOMATION = exports.WORD_PROCESSOR = exports.WIDGETS = exports.WHITE_LABELING = exports.WHISPER_COACHING = exports.WEBSITE_VISITOR_TRACKING = exports.WEBSITE_BUILDER = exports.WEBSITE_ANALYTICS_INTEGRATION = exports.WEB_TRAFFIC_ANALYTICS = exports.WEB_SERVICES = exports.WEB_PORTAL = exports.W3C_COMPLIANCE = exports.VOICEMAIL_AND_NOTIFICATIONS = exports.VISITOR_IDENTIFICATION = exports.VIP_DISCOUNT_TICKETS = exports.VIEWS_DASHBOARDS_REPORTS = exports.VIDEO_STREAMING = exports.VIDEO_LOOPING = exports.VIDEO_HOSTING = exports.VIDEO_CALL_RECORDING = exports.VERSION_CONTROL = exports.VENUE_MANAGEMENT = exports.UTILITIES = exports.USER_ROLE_ACCESS_MANAGEMENT = exports.USER_REGISTRATION_PROCESS = exports.USER_PERMISSIONS = exports.USER_MANAGEMENT = exports.URL_BUILDER = exports.UPLOAD = exports.UPDATES = exports.UNIFIED_CUSTOMER_EXPERIENCE = exports.TRANSFERS_ROUTING = exports.TRAINING_MANAGEMENT = exports.TO_DO_LISTS = exports.TIME_TRACKING_INTEGRATION = exports.TIME_ATTENDENCE_TRACKING = exports.TICKETING = exports.TICKET_ISSUE_TRACKING = exports.TICKET_COLLABORATION = exports.TICKET_BROKERING = exports.THREE_PANE_PROJECT_VIEW = exports.THIRD_PARTY_STORE_INTEGRATION = exports.THIRD_PARTY_INTEGRATIONS = exports.THIRD_PARTY_INTEGRATION = exports.TERRITORY_MANAGEMENT = exports.TEMPLATES = exports.TEMPLATE_MANAGEMENT = exports.TEAM_INBOX = exports.TAX_MANAGEMENT = exports.TAX_FILING = exports.TAX_CALCS = exports.TASK_PROGRESS_TRACKING = exports.TASK_PRIORITIZATION = exports.TASK_MANAGEMENT = exports.TASK_CREATION_ASSIGNMENT = exports.TARGET_ACCOUNT_IDENTIFICATION = exports.TAGGING = exports.TACTICS = exports.SURVEY_TEMPLATE = exports.SURVEY_FOR_FEEDBACK = exports.SURVEY_BUILDER = exports.SUPPLY_CHAIN_MANAGEMENT = exports.SUPPLIER_PROCUREMENT = exports.SUBSCRIBE_UNSUBSCRIBE = exports.STOREFRONT_DESIGN_TOOLS = exports.STORAGE_VIEWING_CAPABILITIES = exports.SOFTWARE_INTEGRATIONS = exports.SOFTWARE_INTEGRATION = exports.SOCIAL_SHARING = exports.SOCIAL_NETWORKING = exports.SOCIAL_NETWORK_INTEGRATION = exports.SOCIAL_MEDIA_PROMOTION = exports.SOCIAL_MEDIA_MONITORING = exports.SOCIAL_MEDIA_MANAGEMENT = exports.SOCIAL_MEDIA_INTEGRATIONS = exports.SOCIAL_MEDIA_INTEGRATION = exports.SOCIAL_MARKETING = exports.SOCIAL_INTEGRATION = exports.SOCIAL_ENGAGEMENT = exports.SOCIAL_CAMPAIGNS = exports.SOCIAL_ADS = exports.SMART_TRIGGERS = exports.SLIDESHOW = exports.SLA_STATUS_INDICATORS = exports.SKIP_LOGIC = exports.SITE_SELECTION = exports.SITE_INTERCEPT_SURVEY = exports.SITE_ANALYTICS = exports.SESSION_MANAGEMENT = exports.SERVICE_LEVEL_AGREEMENT = exports.SEO_TOOLS = exports.SEO_MANAGEMENT = exports.SEO_CONTENT_AUTHORING = exports.SEO = exports.SENDING_OUTBOUND_EMAILS = void 0;
var A_B_TESTING = 'A_B_TESTING';
exports.A_B_TESTING = A_B_TESTING;
var ACCESS_CONTROLS_PERMISSIONS = 'ACCESS_CONTROLS_PERMISSIONS';
exports.ACCESS_CONTROLS_PERMISSIONS = ACCESS_CONTROLS_PERMISSIONS;
var ACCESSIBILITY_ACCESS_PERMISSIONS = 'ACCESSIBILITY_ACCESS_PERMISSIONS';
exports.ACCESSIBILITY_ACCESS_PERMISSIONS = ACCESSIBILITY_ACCESS_PERMISSIONS;
var ACCOUNT_ALERTS = 'ACCOUNT_ALERTS';
exports.ACCOUNT_ALERTS = ACCOUNT_ALERTS;
var ACCOUNT_BASED_ENGAGEMENT = 'ACCOUNT_BASED_ENGAGEMENT';
exports.ACCOUNT_BASED_ENGAGEMENT = ACCOUNT_BASED_ENGAGEMENT;
var ACCOUNT_IDENTIFICATION = 'ACCOUNT_IDENTIFICATION';
exports.ACCOUNT_IDENTIFICATION = ACCOUNT_IDENTIFICATION;
var ACCOUNT_INTELLIGENCE = 'ACCOUNT_INTELLIGENCE';
exports.ACCOUNT_INTELLIGENCE = ACCOUNT_INTELLIGENCE;
var ACCOUNTING_INTEGRATION = 'ACCOUNTING_INTEGRATION';
exports.ACCOUNTING_INTEGRATION = ACCOUNTING_INTEGRATION;
var ACCOUNTS_PAYABLE = 'ACCOUNTS_PAYABLE';
exports.ACCOUNTS_PAYABLE = ACCOUNTS_PAYABLE;
var ACCOUNTS_RECEIVABLE = 'ACCOUNTS_RECEIVABLE';
exports.ACCOUNTS_RECEIVABLE = ACCOUNTS_RECEIVABLE;
var ACTIVITIES = 'ACTIVITIES';
exports.ACTIVITIES = ACTIVITIES;
var ACTIVITY_STREAM_AT_MENTION = 'ACTIVITY_STREAM_AT_MENTION';
exports.ACTIVITY_STREAM_AT_MENTION = ACTIVITY_STREAM_AT_MENTION;
var ADD_ONS = 'ADD_ONS';
exports.ADD_ONS = ADD_ONS;
var ADVANCED_DOCUMENT_MANAGEMENT = 'ADVANCED_DOCUMENT_MANAGEMENT';
exports.ADVANCED_DOCUMENT_MANAGEMENT = ADVANCED_DOCUMENT_MANAGEMENT;
var ADVANCED_SEARCH = 'ADVANCED_SEARCH';
exports.ADVANCED_SEARCH = ADVANCED_SEARCH;
var ADVERTISING = 'ADVERTISING';
exports.ADVERTISING = ADVERTISING;
var AGILE_AT_SCALE_ADVANCED_WORKFLOW_ENGINE = 'AGILE_AT_SCALE_ADVANCED_WORKFLOW_ENGINE';
exports.AGILE_AT_SCALE_ADVANCED_WORKFLOW_ENGINE = AGILE_AT_SCALE_ADVANCED_WORKFLOW_ENGINE;
var AGILE_METHODOLOGIES = 'AGILE_METHODOLOGIES';
exports.AGILE_METHODOLOGIES = AGILE_METHODOLOGIES;
var ALERTS = 'ALERTS';
exports.ALERTS = ALERTS;
var ALERTS_ESCALATION = 'ALERTS_ESCALATION';
exports.ALERTS_ESCALATION = ALERTS_ESCALATION;
var ALERTS_NOTIFICATIONS = 'ALERTS_NOTIFICATIONS';
exports.ALERTS_NOTIFICATIONS = ALERTS_NOTIFICATIONS;
var ANALYTICS = 'ANALYTICS';
exports.ANALYTICS = ANALYTICS;
var ANALYTICS_ROI_TRACKING = 'ANALYTICS_ROI_TRACKING';
exports.ANALYTICS_ROI_TRACKING = ANALYTICS_ROI_TRACKING;
var ANNOTATION = 'ANNOTATION';
exports.ANNOTATION = ANNOTATION;
var ANSWER_FLOWS = 'ANSWER_FLOWS';
exports.ANSWER_FLOWS = ANSWER_FLOWS;
var ANSWER_SCORING = 'ANSWER_SCORING';
exports.ANSWER_SCORING = ANSWER_SCORING;
var APPOINTMENT_SCHEDULING = 'APPOINTMENT_SCHEDULING';
exports.APPOINTMENT_SCHEDULING = APPOINTMENT_SCHEDULING;
var APPOINTMENT_SETTING = 'APPOINTMENT_SETTING';
exports.APPOINTMENT_SETTING = APPOINTMENT_SETTING;
var APPROVAL_PROCESS = 'APPROVAL_PROCESS';
exports.APPROVAL_PROCESS = APPROVAL_PROCESS;
var ARCHIVING = 'ARCHIVING';
exports.ARCHIVING = ARCHIVING;
var ASSET_MANAGEMENT = 'ASSET_MANAGEMENT';
exports.ASSET_MANAGEMENT = ASSET_MANAGEMENT;
var ATTENDEE_MANAGEMENT = 'ATTENDEE_MANAGEMENT';
exports.ATTENDEE_MANAGEMENT = ATTENDEE_MANAGEMENT;
var ATTENDEE_NETWORKING = 'ATTENDEE_NETWORKING';
exports.ATTENDEE_NETWORKING = ATTENDEE_NETWORKING;
var ATTENDEE_REPORTS = 'ATTENDEE_REPORTS';
exports.ATTENDEE_REPORTS = ATTENDEE_REPORTS;
var ATTRIBUTION_REPORTING = 'ATTRIBUTION_REPORTING';
exports.ATTRIBUTION_REPORTING = ATTRIBUTION_REPORTING;
var AUDIT_TRAIL = 'AUDIT_TRAIL';
exports.AUDIT_TRAIL = AUDIT_TRAIL;
var AUDITING = 'AUDITING';
exports.AUDITING = AUDITING;
var AUTO_TAX_PAYMENTS = 'AUTO_TAX_PAYMENTS';
exports.AUTO_TAX_PAYMENTS = AUTO_TAX_PAYMENTS;
var AUTO_UPDATE = 'AUTO_UPDATE';
exports.AUTO_UPDATE = AUTO_UPDATE;
var AUTOMATED_EMAIL_RESPONSES = 'AUTOMATED_EMAIL_RESPONSES';
exports.AUTOMATED_EMAIL_RESPONSES = AUTOMATED_EMAIL_RESPONSES;
var AUTOMATED_PUBLISHING = 'AUTOMATED_PUBLISHING';
exports.AUTOMATED_PUBLISHING = AUTOMATED_PUBLISHING;
var AUTOMATED_ROUTING = 'AUTOMATED_ROUTING';
exports.AUTOMATED_ROUTING = AUTOMATED_ROUTING;
var AUTOMATED_SCHEDULING = 'AUTOMATED_SCHEDULING';
exports.AUTOMATED_SCHEDULING = AUTOMATED_SCHEDULING;
var AUTOMATIC_CALL_DISTRIBUTORS = 'AUTOMATIC_CALL_DISTRIBUTORS';
exports.AUTOMATIC_CALL_DISTRIBUTORS = AUTOMATIC_CALL_DISTRIBUTORS;
var AUTOMATION = 'AUTOMATION';
exports.AUTOMATION = AUTOMATION;
var AUTOMATION_TOOLS = 'AUTOMATION_TOOLS';
exports.AUTOMATION_TOOLS = AUTOMATION_TOOLS;
var AUTORESPONDERS = 'AUTORESPONDERS';
exports.AUTORESPONDERS = AUTORESPONDERS;
var BADGE_MANAGEMENT = 'BADGE_MANAGEMENT';
exports.BADGE_MANAGEMENT = BADGE_MANAGEMENT;
var BARCODE_TICKET_SCANNING = 'BARCODE_TICKET_SCANNING';
exports.BARCODE_TICKET_SCANNING = BARCODE_TICKET_SCANNING;
var BASELINING_KPIS = 'BASELINING_KPIS';
exports.BASELINING_KPIS = BASELINING_KPIS;
var BENEFITS_MANAGEMENT = 'BENEFITS_MANAGEMENT';
exports.BENEFITS_MANAGEMENT = BENEFITS_MANAGEMENT;
var BID_MANAGEMENT = 'BID_MANAGEMENT';
exports.BID_MANAGEMENT = BID_MANAGEMENT;
var BILLING_INVOICING = 'BILLING_INVOICING';
exports.BILLING_INVOICING = BILLING_INVOICING;
var BLENDED_CALL_CENTER = 'BLENDED_CALL_CENTER';
exports.BLENDED_CALL_CENTER = BLENDED_CALL_CENTER;
var BLOGGING = 'BLOGGING';
exports.BLOGGING = BLOGGING;
var BOX_OFFICE_MANAGEMENT = 'BOX_OFFICE_MANAGEMENT';
exports.BOX_OFFICE_MANAGEMENT = BOX_OFFICE_MANAGEMENT;
var BRAND_ALERTS = 'BRAND_ALERTS';
exports.BRAND_ALERTS = BRAND_ALERTS;
var BRAND_OPTIMIZATION = 'BRAND_OPTIMIZATION';
exports.BRAND_OPTIMIZATION = BRAND_OPTIMIZATION;
var BRAND_OVERLAY = 'BRAND_OVERLAY';
exports.BRAND_OVERLAY = BRAND_OVERLAY;
var BRAND_TRACKING = 'BRAND_TRACKING';
exports.BRAND_TRACKING = BRAND_TRACKING;
var BRANDING = 'BRANDING';
exports.BRANDING = BRANDING;
var BUDGET_MANAGEMENT = 'BUDGET_MANAGEMENT';
exports.BUDGET_MANAGEMENT = BUDGET_MANAGEMENT;
var BUDGETING_FORECASTING = 'BUDGETING_FORECASTING';
exports.BUDGETING_FORECASTING = BUDGETING_FORECASTING;
var BUILDING_AND_PERSONALIZING_EMAILS = 'BUILDING_AND_PERSONALIZING_EMAILS';
exports.BUILDING_AND_PERSONALIZING_EMAILS = BUILDING_AND_PERSONALIZING_EMAILS;
var BUILDING_PERSONALIZING_EMAILS = 'BUILDING_PERSONALIZING_EMAILS';
exports.BUILDING_PERSONALIZING_EMAILS = BUILDING_PERSONALIZING_EMAILS;
var BULK_EMAIL_SENDING = 'BULK_EMAIL_SENDING';
exports.BULK_EMAIL_SENDING = BULK_EMAIL_SENDING;
var BULK_UPDATES = 'BULK_UPDATES';
exports.BULK_UPDATES = BULK_UPDATES;
var BULK_UPLOADING = 'BULK_UPLOADING';
exports.BULK_UPLOADING = BULK_UPLOADING;
var BUSINESS_PROCESS_AUTOMATION = 'BUSINESS_PROCESS_AUTOMATION';
exports.BUSINESS_PROCESS_AUTOMATION = BUSINESS_PROCESS_AUTOMATION;
var CALENDAR_MANAGEMENT = 'CALENDAR_MANAGEMENT';
exports.CALENDAR_MANAGEMENT = CALENDAR_MANAGEMENT;
var CALENDAR_REMINDER_SYSTEM = 'CALENDAR_REMINDER_SYSTEM';
exports.CALENDAR_REMINDER_SYSTEM = CALENDAR_REMINDER_SYSTEM;
var CALENDAR_VIEW = 'CALENDAR_VIEW';
exports.CALENDAR_VIEW = CALENDAR_VIEW;
var CALENDARS = 'CALENDARS';
exports.CALENDARS = CALENDARS;
var CALL_BARGING = 'CALL_BARGING';
exports.CALL_BARGING = CALL_BARGING;
var CALL_LOGGING = 'CALL_LOGGING';
exports.CALL_LOGGING = CALL_LOGGING;
var CALL_RECORDING_PLAYBACK = 'CALL_RECORDING_PLAYBACK';
exports.CALL_RECORDING_PLAYBACK = CALL_RECORDING_PLAYBACK;
var CALL_ROUTING = 'CALL_ROUTING';
exports.CALL_ROUTING = CALL_ROUTING;
var CALL_SCRIPTING = 'CALL_SCRIPTING';
exports.CALL_SCRIPTING = CALL_SCRIPTING;
var CALL_SHARING = 'CALL_SHARING';
exports.CALL_SHARING = CALL_SHARING;
var CALL_SUMMARY_NOTES = 'CALL_SUMMARY_NOTES';
exports.CALL_SUMMARY_NOTES = CALL_SUMMARY_NOTES;
var CALLBACK_SCHEDULING = 'CALLBACK_SCHEDULING';
exports.CALLBACK_SCHEDULING = CALLBACK_SCHEDULING;
var CAMPAIGN_INSIGHTS = 'CAMPAIGN_INSIGHTS';
exports.CAMPAIGN_INSIGHTS = CAMPAIGN_INSIGHTS;
var CAMPAIGN_MANAGEMENT = 'CAMPAIGN_MANAGEMENT';
exports.CAMPAIGN_MANAGEMENT = CAMPAIGN_MANAGEMENT;
var CAMPAIGN_PERSONALIZATION = 'CAMPAIGN_PERSONALIZATION';
exports.CAMPAIGN_PERSONALIZATION = CAMPAIGN_PERSONALIZATION;
var CANNED_RESPONSES = 'CANNED_RESPONSES';
exports.CANNED_RESPONSES = CANNED_RESPONSES;
var CATALOGING_CATEGORIZATION = 'CATALOGING_CATEGORIZATION';
exports.CATALOGING_CATEGORIZATION = CATALOGING_CATEGORIZATION;
var CENTRAL_DATABASE = 'CENTRAL_DATABASE';
exports.CENTRAL_DATABASE = CENTRAL_DATABASE;
var CHANNEL_ATTRIBUTION = 'CHANNEL_ATTRIBUTION';
exports.CHANNEL_ATTRIBUTION = CHANNEL_ATTRIBUTION;
var CHAT_MONITORING = 'CHAT_MONITORING';
exports.CHAT_MONITORING = CHAT_MONITORING;
var CHAT_RATING = 'CHAT_RATING';
exports.CHAT_RATING = CHAT_RATING;
var CHAT_ROUTING = 'CHAT_ROUTING';
exports.CHAT_ROUTING = CHAT_ROUTING;
var CLEANSE_STANDARDIZE_DATA = 'CLEANSE_STANDARDIZE_DATA';
exports.CLEANSE_STANDARDIZE_DATA = CLEANSE_STANDARDIZE_DATA;
var CLICK_TO_CALL = 'CLICK_TO_CALL';
exports.CLICK_TO_CALL = CLICK_TO_CALL;
var CLOSED_CAPTIONS = 'CLOSED_CAPTIONS';
exports.CLOSED_CAPTIONS = CLOSED_CAPTIONS;
var COLLABORATION = 'COLLABORATION';
exports.COLLABORATION = COLLABORATION;
var COLLABORATIVE_PROJECT_PLANNING = 'COLLABORATIVE_PROJECT_PLANNING';
exports.COLLABORATIVE_PROJECT_PLANNING = COLLABORATIVE_PROJECT_PLANNING;
var COMMENTS = 'COMMENTS';
exports.COMMENTS = COMMENTS;
var COMPETITIVE_ANALYSIS = 'COMPETITIVE_ANALYSIS';
exports.COMPETITIVE_ANALYSIS = COMPETITIVE_ANALYSIS;
var COMPETITOR_ANALYSIS = 'COMPETITOR_ANALYSIS';
exports.COMPETITOR_ANALYSIS = COMPETITOR_ANALYSIS;
var COMPLIANCE_TRACKING = 'COMPLIANCE_TRACKING';
exports.COMPLIANCE_TRACKING = COMPLIANCE_TRACKING;
var COMPUTER_TELEPHONY_INTEGRATION = 'COMPUTER_TELEPHONY_INTEGRATION';
exports.COMPUTER_TELEPHONY_INTEGRATION = COMPUTER_TELEPHONY_INTEGRATION;
var CONCESSIONS_MANAGEMENT = 'CONCESSIONS_MANAGEMENT';
exports.CONCESSIONS_MANAGEMENT = CONCESSIONS_MANAGEMENT;
var CONFERENCES_CONVENTIONS = 'CONFERENCES_CONVENTIONS';
exports.CONFERENCES_CONVENTIONS = CONFERENCES_CONVENTIONS;
var CONTACT_ACCOUNT_MANAGEMENT = 'CONTACT_ACCOUNT_MANAGEMENT';
exports.CONTACT_ACCOUNT_MANAGEMENT = CONTACT_ACCOUNT_MANAGEMENT;
var CONTACT_DATABASE_MANAGEMENT = 'CONTACT_DATABASE_MANAGEMENT';
exports.CONTACT_DATABASE_MANAGEMENT = CONTACT_DATABASE_MANAGEMENT;
var CONTACT_DISCOVERY = 'CONTACT_DISCOVERY';
exports.CONTACT_DISCOVERY = CONTACT_DISCOVERY;
var CONTACT_IMPORT_EXPORT = 'CONTACT_IMPORT_EXPORT';
exports.CONTACT_IMPORT_EXPORT = CONTACT_IMPORT_EXPORT;
var CONTACT_LIST_MANAGEMENT = 'CONTACT_LIST_MANAGEMENT';
exports.CONTACT_LIST_MANAGEMENT = CONTACT_LIST_MANAGEMENT;
var CONTACT_MANAGEMENT = 'CONTACT_MANAGEMENT';
exports.CONTACT_MANAGEMENT = CONTACT_MANAGEMENT;
var CONTENT_AGGREGATION = 'CONTENT_AGGREGATION';
exports.CONTENT_AGGREGATION = CONTENT_AGGREGATION;
var CONTENT_AUTHORING = 'CONTENT_AUTHORING';
exports.CONTENT_AUTHORING = CONTENT_AUTHORING;
var CONTENT_CREATION = 'CONTENT_CREATION';
exports.CONTENT_CREATION = CONTENT_CREATION;
var CONTENT_IMPORT_EXPORT = 'CONTENT_IMPORT_EXPORT';
exports.CONTENT_IMPORT_EXPORT = CONTENT_IMPORT_EXPORT;
var CONTENT_MANAGEMENT = 'CONTENT_MANAGEMENT';
exports.CONTENT_MANAGEMENT = CONTENT_MANAGEMENT;
var CONTENT_QUEUE = 'CONTENT_QUEUE';
exports.CONTENT_QUEUE = CONTENT_QUEUE;
var CONTENT_REPOSITORY = 'CONTENT_REPOSITORY';
exports.CONTENT_REPOSITORY = CONTENT_REPOSITORY;
var CONTENT_TAXONOMY = 'CONTENT_TAXONOMY';
exports.CONTENT_TAXONOMY = CONTENT_TAXONOMY;
var CONTROLLED_TELEPHONY = 'CONTROLLED_TELEPHONY';
exports.CONTROLLED_TELEPHONY = CONTROLLED_TELEPHONY;
var CONVERSATION_ARCHIVING = 'CONVERSATION_ARCHIVING';
exports.CONVERSATION_ARCHIVING = CONVERSATION_ARCHIVING;
var CONVERSION_TRACKING = 'CONVERSION_TRACKING';
exports.CONVERSION_TRACKING = CONVERSION_TRACKING;
var CONVERSIONS = 'CONVERSIONS';
exports.CONVERSIONS = CONVERSIONS;
var CORE_HR_INTEGRATION = 'CORE_HR_INTEGRATION';
exports.CORE_HR_INTEGRATION = CORE_HR_INTEGRATION;
var CRM = 'CRM';
exports.CRM = CRM;
var CRM_INTEGRATION = 'CRM_INTEGRATION';
exports.CRM_INTEGRATION = CRM_INTEGRATION;
var CRM_LEAD_INTEGRATION = 'CRM_LEAD_INTEGRATION';
exports.CRM_LEAD_INTEGRATION = CRM_LEAD_INTEGRATION;
var CROSS_CHANNEL_FULFILLMENT = 'CROSS_CHANNEL_FULFILLMENT';
exports.CROSS_CHANNEL_FULFILLMENT = CROSS_CHANNEL_FULFILLMENT;
var CUSTOM_REPORTING = 'CUSTOM_REPORTING';
exports.CUSTOM_REPORTING = CUSTOM_REPORTING;
var CUSTOM_SURVEY_URLS = 'CUSTOM_SURVEY_URLS';
exports.CUSTOM_SURVEY_URLS = CUSTOM_SURVEY_URLS;
var CUSTOMER_ANALYTICS_SEGMENTATION = 'CUSTOMER_ANALYTICS_SEGMENTATION';
exports.CUSTOMER_ANALYTICS_SEGMENTATION = CUSTOMER_ANALYTICS_SEGMENTATION;
var CUSTOMER_DATABASE = 'CUSTOMER_DATABASE';
exports.CUSTOMER_DATABASE = CUSTOMER_DATABASE;
var CUSTOMER_ENGAGEMENT = 'CUSTOMER_ENGAGEMENT';
exports.CUSTOMER_ENGAGEMENT = CUSTOMER_ENGAGEMENT;
var CUSTOMER_JOURNEY_MAPPING = 'CUSTOMER_JOURNEY_MAPPING';
exports.CUSTOMER_JOURNEY_MAPPING = CUSTOMER_JOURNEY_MAPPING;
var CUSTOMER_PORTAL = 'CUSTOMER_PORTAL';
exports.CUSTOMER_PORTAL = CUSTOMER_PORTAL;
var CUSTOMER_PROFILE_INTERVIEW = 'CUSTOMER_PROFILE_INTERVIEW';
exports.CUSTOMER_PROFILE_INTERVIEW = CUSTOMER_PROFILE_INTERVIEW;
var CUSTOMER_PROFILES = 'CUSTOMER_PROFILES';
exports.CUSTOMER_PROFILES = CUSTOMER_PROFILES;
var CUSTOMER_SATISFACTION_SURVEY = 'CUSTOMER_SATISFACTION_SURVEY';
exports.CUSTOMER_SATISFACTION_SURVEY = CUSTOMER_SATISFACTION_SURVEY;
var CUSTOMER_SCHEDULING = 'CUSTOMER_SCHEDULING';
exports.CUSTOMER_SCHEDULING = CUSTOMER_SCHEDULING;
var CUSTOMER_SEGMENTATION = 'CUSTOMER_SEGMENTATION';
exports.CUSTOMER_SEGMENTATION = CUSTOMER_SEGMENTATION;
var CUSTOMIZABLE_BRANDING = 'CUSTOMIZABLE_BRANDING';
exports.CUSTOMIZABLE_BRANDING = CUSTOMIZABLE_BRANDING;
var CUSTOMIZABLE_DASHBOARD = 'CUSTOMIZABLE_DASHBOARD';
exports.CUSTOMIZABLE_DASHBOARD = CUSTOMIZABLE_DASHBOARD;
var CUSTOMIZABLE_TEMPLATES = 'CUSTOMIZABLE_TEMPLATES';
exports.CUSTOMIZABLE_TEMPLATES = CUSTOMIZABLE_TEMPLATES;
var CUSTOMIZATION = 'CUSTOMIZATION';
exports.CUSTOMIZATION = CUSTOMIZATION;
var DASHBOARD = 'DASHBOARD';
exports.DASHBOARD = DASHBOARD;
var DASHBOARDS = 'DASHBOARDS';
exports.DASHBOARDS = DASHBOARDS;
var DATA_ANALYSIS_TOOLS = 'DATA_ANALYSIS_TOOLS';
exports.DATA_ANALYSIS_TOOLS = DATA_ANALYSIS_TOOLS;
var DATA_COLLECTION = 'DATA_COLLECTION';
exports.DATA_COLLECTION = DATA_COLLECTION;
var DATA_FORMATING = 'DATA_FORMATING';
exports.DATA_FORMATING = DATA_FORMATING;
var DATA_IMPORT_EXPORT = 'DATA_IMPORT_EXPORT';
exports.DATA_IMPORT_EXPORT = DATA_IMPORT_EXPORT;
var DATA_IMPORT_EXPORT_TOOLS = 'DATA_IMPORT_EXPORT_TOOLS';
exports.DATA_IMPORT_EXPORT_TOOLS = DATA_IMPORT_EXPORT_TOOLS;
var DATA_MIGRATION = 'DATA_MIGRATION';
exports.DATA_MIGRATION = DATA_MIGRATION;
var DATA_VISUALIZATION = 'DATA_VISUALIZATION';
exports.DATA_VISUALIZATION = DATA_VISUALIZATION;
var DATABASE_MANAGEMENT = 'DATABASE_MANAGEMENT';
exports.DATABASE_MANAGEMENT = DATABASE_MANAGEMENT;
var DEAL_MANAGEMENT_PROMOTIONS = 'DEAL_MANAGEMENT_PROMOTIONS';
exports.DEAL_MANAGEMENT_PROMOTIONS = DEAL_MANAGEMENT_PROMOTIONS;
var DECISION_TREE = 'DECISION_TREE';
exports.DECISION_TREE = DECISION_TREE;
var DELIVERY = 'DELIVERY';
exports.DELIVERY = DELIVERY;
var DEPENDENCIES = 'DEPENDENCIES';
exports.DEPENDENCIES = DEPENDENCIES;
var DIRECT_DEPOSIT = 'DIRECT_DEPOSIT';
exports.DIRECT_DEPOSIT = DIRECT_DEPOSIT;
var DISCUSSION_BOARDS = 'DISCUSSION_BOARDS';
exports.DISCUSSION_BOARDS = DISCUSSION_BOARDS;
var DISPOSITION_CODES = 'DISPOSITION_CODES';
exports.DISPOSITION_CODES = DISPOSITION_CODES;
var DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT';
exports.DOCUMENT_MANAGEMENT = DOCUMENT_MANAGEMENT;
var DOCUMENT_STORAGE = 'DOCUMENT_STORAGE';
exports.DOCUMENT_STORAGE = DOCUMENT_STORAGE;
var DOMAIN_NAME = 'DOMAIN_NAME';
exports.DOMAIN_NAME = DOMAIN_NAME;
var DRAG_DROP = 'DRAG_DROP';
exports.DRAG_DROP = DRAG_DROP;
var DRIP_CAMPAIGNS = 'DRIP_CAMPAIGNS';
exports.DRIP_CAMPAIGNS = DRIP_CAMPAIGNS;
var DUE_DATES = 'DUE_DATES';
exports.DUE_DATES = DUE_DATES;
var DYNAMIC_CONTENT = 'DYNAMIC_CONTENT';
exports.DYNAMIC_CONTENT = DYNAMIC_CONTENT;
var E_COMMERCE = 'E_COMMERCE';
exports.E_COMMERCE = E_COMMERCE;
var EASY_ADMINISTRATION = 'EASY_ADMINISTRATION';
exports.EASY_ADMINISTRATION = EASY_ADMINISTRATION;
var EASY_INTEGRATIONS = 'EASY_INTEGRATIONS';
exports.EASY_INTEGRATIONS = EASY_INTEGRATIONS;
var ECOMMERCE = 'ECOMMERCE';
exports.ECOMMERCE = ECOMMERCE;
var EFFECTIVE_REPORTING_ANALYTICS = 'EFFECTIVE_REPORTING_ANALYTICS';
exports.EFFECTIVE_REPORTING_ANALYTICS = EFFECTIVE_REPORTING_ANALYTICS;
var EFFECTIVE_TIME_TRACKING = 'EFFECTIVE_TIME_TRACKING';
exports.EFFECTIVE_TIME_TRACKING = EFFECTIVE_TIME_TRACKING;
var EFFICIENT_WORKLOAD_PERFORMANCE_MANAGEMENT = 'EFFICIENT_WORKLOAD_PERFORMANCE_MANAGEMENT';
exports.EFFICIENT_WORKLOAD_PERFORMANCE_MANAGEMENT = EFFICIENT_WORKLOAD_PERFORMANCE_MANAGEMENT;
var EMAIL_AUTOMATION = 'EMAIL_AUTOMATION';
exports.EMAIL_AUTOMATION = EMAIL_AUTOMATION;
var EMAIL_CUSTOMIZATION = 'EMAIL_CUSTOMIZATION';
exports.EMAIL_CUSTOMIZATION = EMAIL_CUSTOMIZATION;
var EMAIL_INTEGRATION = 'EMAIL_INTEGRATION';
exports.EMAIL_INTEGRATION = EMAIL_INTEGRATION;
var EMAIL_INTEGRATIONS = 'EMAIL_INTEGRATIONS';
exports.EMAIL_INTEGRATIONS = EMAIL_INTEGRATIONS;
var EMAIL_MARKETING = 'EMAIL_MARKETING';
exports.EMAIL_MARKETING = EMAIL_MARKETING;
var EMAIL_MOBILE_PREVIEW = 'EMAIL_MOBILE_PREVIEW';
exports.EMAIL_MOBILE_PREVIEW = EMAIL_MOBILE_PREVIEW;
var EMAIL_TO_CASE = 'EMAIL_TO_CASE';
exports.EMAIL_TO_CASE = EMAIL_TO_CASE;
var EMAIL_TRACKING = 'EMAIL_TRACKING';
exports.EMAIL_TRACKING = EMAIL_TRACKING;
var EMPLOYEE_SCHEDULING = 'EMPLOYEE_SCHEDULING';
exports.EMPLOYEE_SCHEDULING = EMPLOYEE_SCHEDULING;
var ENGAGEMENT_MONITORING = 'ENGAGEMENT_MONITORING';
exports.ENGAGEMENT_MONITORING = ENGAGEMENT_MONITORING;
var ENTERPRISE_SCALABILITY = 'ENTERPRISE_SCALABILITY';
exports.ENTERPRISE_SCALABILITY = ENTERPRISE_SCALABILITY;
var ESCALATION_MANAGEMENT = 'ESCALATION_MANAGEMENT';
exports.ESCALATION_MANAGEMENT = ESCALATION_MANAGEMENT;
var ETL = 'ETL';
exports.ETL = ETL;
var EVENT_CREATION = 'EVENT_CREATION';
exports.EVENT_CREATION = EVENT_CREATION;
var EVENT_MANAGEMENT = 'EVENT_MANAGEMENT';
exports.EVENT_MANAGEMENT = EVENT_MANAGEMENT;
var EVENT_MARKETING = 'EVENT_MARKETING';
exports.EVENT_MARKETING = EVENT_MARKETING;
var EVENT_REPORTING = 'EVENT_REPORTING';
exports.EVENT_REPORTING = EVENT_REPORTING;
var EVENT_TRIGGERED_EMAIL = 'EVENT_TRIGGERED_EMAIL';
exports.EVENT_TRIGGERED_EMAIL = EVENT_TRIGGERED_EMAIL;
var EVENT_WEBSITE_CREATION = 'EVENT_WEBSITE_CREATION';
exports.EVENT_WEBSITE_CREATION = EVENT_WEBSITE_CREATION;
var EXHIBIT_VENDOR_MANAGEMENT = 'EXHIBIT_VENDOR_MANAGEMENT';
exports.EXHIBIT_VENDOR_MANAGEMENT = EXHIBIT_VENDOR_MANAGEMENT;
var EXPENSE_MANAGEMENT = 'EXPENSE_MANAGEMENT';
exports.EXPENSE_MANAGEMENT = EXPENSE_MANAGEMENT;
var EXPERTISE_LOCATION = 'EXPERTISE_LOCATION';
exports.EXPERTISE_LOCATION = EXPERTISE_LOCATION;
var EXTRACT_TRANSFER_LOAD = 'EXTRACT_TRANSFER_LOAD';
exports.EXTRACT_TRANSFER_LOAD = EXTRACT_TRANSFER_LOAD;
var FACILITY_SCHEDULING = 'FACILITY_SCHEDULING';
exports.FACILITY_SCHEDULING = FACILITY_SCHEDULING;
var FILE_SHARING = 'FILE_SHARING';
exports.FILE_SHARING = FILE_SHARING;
var FILE_TRANSFER = 'FILE_TRANSFER';
exports.FILE_TRANSFER = FILE_TRANSFER;
var FILE_TRANSFERS = 'FILE_TRANSFERS';
exports.FILE_TRANSFERS = FILE_TRANSFERS;
var FILE_VIEWING = 'FILE_VIEWING';
exports.FILE_VIEWING = FILE_VIEWING;
var FINANCIAL_MANAGEMENT = 'FINANCIAL_MANAGEMENT';
exports.FINANCIAL_MANAGEMENT = FINANCIAL_MANAGEMENT;
var FIRMOGRAPHIC = 'FIRMOGRAPHIC';
exports.FIRMOGRAPHIC = FIRMOGRAPHIC;
var FLOWS = 'FLOWS';
exports.FLOWS = FLOWS;
var FORECASTING = 'FORECASTING';
exports.FORECASTING = FORECASTING;
var FORMS = 'FORMS';
exports.FORMS = FORMS;
var FORMS_MANAGEMENT = 'FORMS_MANAGEMENT';
exports.FORMS_MANAGEMENT = FORMS_MANAGEMENT;
var FORUMS = 'FORUMS';
exports.FORUMS = FORUMS;
var FULL_TEXT_SEARCH = 'FULL_TEXT_SEARCH';
exports.FULL_TEXT_SEARCH = FULL_TEXT_SEARCH;
var FUND_ACCOUNTING = 'FUND_ACCOUNTING';
exports.FUND_ACCOUNTING = FUND_ACCOUNTING;
var FUNDRAISING_MANAGEMENT = 'FUNDRAISING_MANAGEMENT';
exports.FUNDRAISING_MANAGEMENT = FUNDRAISING_MANAGEMENT;
var GALLERIES = 'GALLERIES';
exports.GALLERIES = GALLERIES;
var GAMIFICATION = 'GAMIFICATION';
exports.GAMIFICATION = GAMIFICATION;
var GANTT_CHARTS = 'GANTT_CHARTS';
exports.GANTT_CHARTS = GANTT_CHARTS;
var GENERAL_ADMISSION = 'GENERAL_ADMISSION';
exports.GENERAL_ADMISSION = GENERAL_ADMISSION;
var GEO_TARGETING = 'GEO_TARGETING';
exports.GEO_TARGETING = GEO_TARGETING;
var GOALS_QUOTA_MANAGEMENT = 'GOALS_QUOTA_MANAGEMENT';
exports.GOALS_QUOTA_MANAGEMENT = GOALS_QUOTA_MANAGEMENT;
var GRAPHICAL_WORKFLOW_EDITOR = 'GRAPHICAL_WORKFLOW_EDITOR';
exports.GRAPHICAL_WORKFLOW_EDITOR = GRAPHICAL_WORKFLOW_EDITOR;
var GROUP_SCHEDULING = 'GROUP_SCHEDULING';
exports.GROUP_SCHEDULING = GROUP_SCHEDULING;
var HELP_DESK = 'HELP_DESK';
exports.HELP_DESK = HELP_DESK;
var HIGH_VOLUME_SENDING = 'HIGH_VOLUME_SENDING';
exports.HIGH_VOLUME_SENDING = HIGH_VOLUME_SENDING;
var HOME_PRINTING = 'HOME_PRINTING';
exports.HOME_PRINTING = HOME_PRINTING;
var HOSTING = 'HOSTING';
exports.HOSTING = HOSTING;
var HR_MANAGEMENT = 'HR_MANAGEMENT';
exports.HR_MANAGEMENT = HR_MANAGEMENT;
var HTML_INPUT = 'HTML_INPUT';
exports.HTML_INPUT = HTML_INPUT;
var IDEA_MANAGEMENT = 'IDEA_MANAGEMENT';
exports.IDEA_MANAGEMENT = IDEA_MANAGEMENT;
var IDEAL_CUSTOMER_PROFILE = 'IDEAL_CUSTOMER_PROFILE';
exports.IDEAL_CUSTOMER_PROFILE = IDEAL_CUSTOMER_PROFILE;
var IMAGE_GALLERY = 'IMAGE_GALLERY';
exports.IMAGE_GALLERY = IMAGE_GALLERY;
var IN_APP_MESSAGING = 'IN_APP_MESSAGING';
exports.IN_APP_MESSAGING = IN_APP_MESSAGING;
var INBOUND_CALL_CENTER = 'INBOUND_CALL_CENTER';
exports.INBOUND_CALL_CENTER = INBOUND_CALL_CENTER;
var INSIGHTFUL_VIEWS = 'INSIGHTFUL_VIEWS';
exports.INSIGHTFUL_VIEWS = INSIGHTFUL_VIEWS;
var INSTANT_RETRIEVAL = 'INSTANT_RETRIEVAL';
exports.INSTANT_RETRIEVAL = INSTANT_RETRIEVAL;
var INTEGRATION = 'INTEGRATION';
exports.INTEGRATION = INTEGRATION;
var INTEGRATION_APIS = 'INTEGRATION_APIS';
exports.INTEGRATION_APIS = INTEGRATION_APIS;
var INTEGRATIONS = 'INTEGRATIONS';
exports.INTEGRATIONS = INTEGRATIONS;
var INTERACTION_TRACKING = 'INTERACTION_TRACKING';
exports.INTERACTION_TRACKING = INTERACTION_TRACKING;
var INTERACTIVE_VOICE_RESPONSE = 'INTERACTIVE_VOICE_RESPONSE';
exports.INTERACTIVE_VOICE_RESPONSE = INTERACTIVE_VOICE_RESPONSE;
var INTERACTIVE_VOICE_RESPONSES = 'INTERACTIVE_VOICE_RESPONSES';
exports.INTERACTIVE_VOICE_RESPONSES = INTERACTIVE_VOICE_RESPONSES;
var INTERNAL_CHAT_INTEGRATION = 'INTERNAL_CHAT_INTEGRATION';
exports.INTERNAL_CHAT_INTEGRATION = INTERNAL_CHAT_INTEGRATION;
var INVENTORY_MANAGEMENT = 'INVENTORY_MANAGEMENT';
exports.INVENTORY_MANAGEMENT = INVENTORY_MANAGEMENT;
var INVENTORY_REPORTING = 'INVENTORY_REPORTING';
exports.INVENTORY_REPORTING = INVENTORY_REPORTING;
var INVOICE_CUSTOMIZATION = 'INVOICE_CUSTOMIZATION';
exports.INVOICE_CUSTOMIZATION = INVOICE_CUSTOMIZATION;
var IT_ASSET_MANAGEMENT = 'IT_ASSET_MANAGEMENT';
exports.IT_ASSET_MANAGEMENT = IT_ASSET_MANAGEMENT;
var IVR_VOICE_RECOGNITION = 'IVR_VOICE_RECOGNITION';
exports.IVR_VOICE_RECOGNITION = IVR_VOICE_RECOGNITION;
var JOURNAL_ENTRIES = 'JOURNAL_ENTRIES';
exports.JOURNAL_ENTRIES = JOURNAL_ENTRIES;
var KEYWORD_ANALYSIS = 'KEYWORD_ANALYSIS';
exports.KEYWORD_ANALYSIS = KEYWORD_ANALYSIS;
var KEYWORD_RESEARCH = 'KEYWORD_RESEARCH';
exports.KEYWORD_RESEARCH = KEYWORD_RESEARCH;
var KEYWORD_TRACKING = 'KEYWORD_TRACKING';
exports.KEYWORD_TRACKING = KEYWORD_TRACKING;
var KIOSK_TICKETING = 'KIOSK_TICKETING';
exports.KIOSK_TICKETING = KIOSK_TICKETING;
var KNOWLEDGE_BASE = 'KNOWLEDGE_BASE';
exports.KNOWLEDGE_BASE = KNOWLEDGE_BASE;
var KNOWLEDGE_BASE_MANAGEMENT = 'KNOWLEDGE_BASE_MANAGEMENT';
exports.KNOWLEDGE_BASE_MANAGEMENT = KNOWLEDGE_BASE_MANAGEMENT;
var KPI_BASED_REPORTS = 'KPI_BASED_REPORTS';
exports.KPI_BASED_REPORTS = KPI_BASED_REPORTS;
var LANDING_PAGES_WEB_FORMS = 'LANDING_PAGES_WEB_FORMS';
exports.LANDING_PAGES_WEB_FORMS = LANDING_PAGES_WEB_FORMS;
var LEAD_ANAYSIS = 'LEAD_ANAYSIS';
exports.LEAD_ANAYSIS = LEAD_ANAYSIS;
var LEAD_CAPTURE = 'LEAD_CAPTURE';
exports.LEAD_CAPTURE = LEAD_CAPTURE;
var LEAD_DATABASE_INTEGRATION = 'LEAD_DATABASE_INTEGRATION';
exports.LEAD_DATABASE_INTEGRATION = LEAD_DATABASE_INTEGRATION;
var LEAD_DEVELOPMENT = 'LEAD_DEVELOPMENT';
exports.LEAD_DEVELOPMENT = LEAD_DEVELOPMENT;
var LEAD_GENERATION_RETRIEVAL = 'LEAD_GENERATION_RETRIEVAL';
exports.LEAD_GENERATION_RETRIEVAL = LEAD_GENERATION_RETRIEVAL;
var LEAD_MANAGEMENT = 'LEAD_MANAGEMENT';
exports.LEAD_MANAGEMENT = LEAD_MANAGEMENT;
var LEAD_NURTURING = 'LEAD_NURTURING';
exports.LEAD_NURTURING = LEAD_NURTURING;
var LEAD_SCORING = 'LEAD_SCORING';
exports.LEAD_SCORING = LEAD_SCORING;
var LEAD_SEGMENTATION = 'LEAD_SEGMENTATION';
exports.LEAD_SEGMENTATION = LEAD_SEGMENTATION;
var LEAVE_TRACKING = 'LEAVE_TRACKING';
exports.LEAVE_TRACKING = LEAVE_TRACKING;
var LINK_MANAGEMENT = 'LINK_MANAGEMENT';
exports.LINK_MANAGEMENT = LINK_MANAGEMENT;
var LINK_SHARING = 'LINK_SHARING';
exports.LINK_SHARING = LINK_SHARING;
var LIVE_CHAT = 'LIVE_CHAT';
exports.LIVE_CHAT = LIVE_CHAT;
var LIVE_PRESENTATION = 'LIVE_PRESENTATION';
exports.LIVE_PRESENTATION = LIVE_PRESENTATION;
var LOCALIZATION = 'LOCALIZATION';
exports.LOCALIZATION = LOCALIZATION;
var MAILING_LIST_MANAGEMENT = 'MAILING_LIST_MANAGEMENT';
exports.MAILING_LIST_MANAGEMENT = MAILING_LIST_MANAGEMENT;
var MAKE_RECEIVE_RECORD_CALLS = 'MAKE_RECEIVE_RECORD_CALLS';
exports.MAKE_RECEIVE_RECORD_CALLS = MAKE_RECEIVE_RECORD_CALLS;
var MANUAL_DIALER = 'MANUAL_DIALER';
exports.MANUAL_DIALER = MANUAL_DIALER;
var MANUFACTURING = 'MANUFACTURING';
exports.MANUFACTURING = MANUFACTURING;
var MARKETING_AUTOMATION_INTEGRATION = 'MARKETING_AUTOMATION_INTEGRATION';
exports.MARKETING_AUTOMATION_INTEGRATION = MARKETING_AUTOMATION_INTEGRATION;
var MARKETING_LEAD_DATABASE = 'MARKETING_LEAD_DATABASE';
exports.MARKETING_LEAD_DATABASE = MARKETING_LEAD_DATABASE;
var MEDIA = 'MEDIA';
exports.MEDIA = MEDIA;
var MEETING_MANAGEMENT = 'MEETING_MANAGEMENT';
exports.MEETING_MANAGEMENT = MEETING_MANAGEMENT;
var MEMBERSHIP = 'MEMBERSHIP';
exports.MEMBERSHIP = MEMBERSHIP;
var MERGE_DUPLICATES = 'MERGE_DUPLICATES';
exports.MERGE_DUPLICATES = MERGE_DUPLICATES;
var METADATA_MANAGEMENT = 'METADATA_MANAGEMENT';
exports.METADATA_MANAGEMENT = METADATA_MANAGEMENT;
var MILESTONE_TRACKING = 'MILESTONE_TRACKING';
exports.MILESTONE_TRACKING = MILESTONE_TRACKING;
var MOBILE = 'MOBILE';
exports.MOBILE = MOBILE;
var MOBILE_ACCESS = 'MOBILE_ACCESS';
exports.MOBILE_ACCESS = MOBILE_ACCESS;
var MOBILE_APP = 'MOBILE_APP';
exports.MOBILE_APP = MOBILE_APP;
var MOBILE_CHECK_IN = 'MOBILE_CHECK_IN';
exports.MOBILE_CHECK_IN = MOBILE_CHECK_IN;
var MOBILE_OPTIMIZATION = 'MOBILE_OPTIMIZATION';
exports.MOBILE_OPTIMIZATION = MOBILE_OPTIMIZATION;
var MOBILE_OPTIONS = 'MOBILE_OPTIONS';
exports.MOBILE_OPTIONS = MOBILE_OPTIONS;
var MOBILE_PRESENTATION = 'MOBILE_PRESENTATION';
exports.MOBILE_PRESENTATION = MOBILE_PRESENTATION;
var MOBILE_SCREEN_SUPPORT = 'MOBILE_SCREEN_SUPPORT';
exports.MOBILE_SCREEN_SUPPORT = MOBILE_SCREEN_SUPPORT;
var MOBILE_SEARCH_TRACKING = 'MOBILE_SEARCH_TRACKING';
exports.MOBILE_SEARCH_TRACKING = MOBILE_SEARCH_TRACKING;
var MOBILE_SUPPORT = 'MOBILE_SUPPORT';
exports.MOBILE_SUPPORT = MOBILE_SUPPORT;
var MOBILE_SURVEY = 'MOBILE_SURVEY';
exports.MOBILE_SURVEY = MOBILE_SURVEY;
var MOBILE_TICKETING = 'MOBILE_TICKETING';
exports.MOBILE_TICKETING = MOBILE_TICKETING;
var MULTI_ACCOUNT_MANAGEMENT = 'MULTI_ACCOUNT_MANAGEMENT';
exports.MULTI_ACCOUNT_MANAGEMENT = MULTI_ACCOUNT_MANAGEMENT;
var MULTI_CHANNEL_COMMUNICATION = 'MULTI_CHANNEL_COMMUNICATION';
exports.MULTI_CHANNEL_COMMUNICATION = MULTI_CHANNEL_COMMUNICATION;
var MULTI_HOSTS = 'MULTI_HOSTS';
exports.MULTI_HOSTS = MULTI_HOSTS;
var MULTI_LOCATION = 'MULTI_LOCATION';
exports.MULTI_LOCATION = MULTI_LOCATION;
var MULTI_USER_COLLABORATION = 'MULTI_USER_COLLABORATION';
exports.MULTI_USER_COLLABORATION = MULTI_USER_COLLABORATION;
var MULTILINGUAL_SUPPORT = 'MULTILINGUAL_SUPPORT';
exports.MULTILINGUAL_SUPPORT = MULTILINGUAL_SUPPORT;
var MULTIMEDIA_SUPPORT = 'MULTIMEDIA_SUPPORT';
exports.MULTIMEDIA_SUPPORT = MULTIMEDIA_SUPPORT;
var MULTIPLE_DATA_SOURCES = 'MULTIPLE_DATA_SOURCES';
exports.MULTIPLE_DATA_SOURCES = MULTIPLE_DATA_SOURCES;
var NETWORK_MONITORING = 'NETWORK_MONITORING';
exports.NETWORK_MONITORING = NETWORK_MONITORING;
var NEWSLETTERS = 'NEWSLETTERS';
exports.NEWSLETTERS = NEWSLETTERS;
var NONPROFITS = 'NONPROFITS';
exports.NONPROFITS = NONPROFITS;
var NOTIFICATIONS = 'NOTIFICATIONS';
exports.NOTIFICATIONS = NOTIFICATIONS;
var OFFLINE_FORM = 'OFFLINE_FORM';
exports.OFFLINE_FORM = OFFLINE_FORM;
var OFFLINE_RESPONSE_COLLECTION = 'OFFLINE_RESPONSE_COLLECTION';
exports.OFFLINE_RESPONSE_COLLECTION = OFFLINE_RESPONSE_COLLECTION;
var ON_SITE_EVENT_MANAGEMENT = 'ON_SITE_EVENT_MANAGEMENT';
exports.ON_SITE_EVENT_MANAGEMENT = ON_SITE_EVENT_MANAGEMENT;
var ONLINE_BEHAVIOR_TRACKING = 'ONLINE_BEHAVIOR_TRACKING';
exports.ONLINE_BEHAVIOR_TRACKING = ONLINE_BEHAVIOR_TRACKING;
var ONLINE_BOOKING = 'ONLINE_BOOKING';
exports.ONLINE_BOOKING = ONLINE_BOOKING;
var ONLINE_BOOKING_TOOLS = 'ONLINE_BOOKING_TOOLS';
exports.ONLINE_BOOKING_TOOLS = ONLINE_BOOKING_TOOLS;
var ONLINE_EVENT_REGISTRATION = 'ONLINE_EVENT_REGISTRATION';
exports.ONLINE_EVENT_REGISTRATION = ONLINE_EVENT_REGISTRATION;
var ONLINE_PAYMENT_ACCEPTANCE = 'ONLINE_PAYMENT_ACCEPTANCE';
exports.ONLINE_PAYMENT_ACCEPTANCE = ONLINE_PAYMENT_ACCEPTANCE;
var ONLINE_STORE_BUILDER = 'ONLINE_STORE_BUILDER';
exports.ONLINE_STORE_BUILDER = ONLINE_STORE_BUILDER;
var ONLINE_TICKETING = 'ONLINE_TICKETING';
exports.ONLINE_TICKETING = ONLINE_TICKETING;
var ONSITE_MANAGEMENT = 'ONSITE_MANAGEMENT';
exports.ONSITE_MANAGEMENT = ONSITE_MANAGEMENT;
var ONSITE_TICKETING = 'ONSITE_TICKETING';
exports.ONSITE_TICKETING = ONSITE_TICKETING;
var OPEN_API = 'OPEN_API';
exports.OPEN_API = OPEN_API;
var OPERATOR_MONITORING = 'OPERATOR_MONITORING';
exports.OPERATOR_MONITORING = OPERATOR_MONITORING;
var OPPORTUNITY_PIPELINE_MANAGEMENT = 'OPPORTUNITY_PIPELINE_MANAGEMENT';
exports.OPPORTUNITY_PIPELINE_MANAGEMENT = OPPORTUNITY_PIPELINE_MANAGEMENT;
var ORDER_MANAGEMENT = 'ORDER_MANAGEMENT';
exports.ORDER_MANAGEMENT = ORDER_MANAGEMENT;
var OUTBOUND_CALL_CENTER = 'OUTBOUND_CALL_CENTER';
exports.OUTBOUND_CALL_CENTER = OUTBOUND_CALL_CENTER;
var PAGE_MANAGEMENT = 'PAGE_MANAGEMENT';
exports.PAGE_MANAGEMENT = PAGE_MANAGEMENT;
var PAYMENT_PROCESSING = 'PAYMENT_PROCESSING';
exports.PAYMENT_PROCESSING = PAYMENT_PROCESSING;
var PAYROLL_ENTRY = 'PAYROLL_ENTRY';
exports.PAYROLL_ENTRY = PAYROLL_ENTRY;
var PERFORMANCE_MANAGEMENT = 'PERFORMANCE_MANAGEMENT';
exports.PERFORMANCE_MANAGEMENT = PERFORMANCE_MANAGEMENT;
var PERSONALIZATION = 'PERSONALIZATION';
exports.PERSONALIZATION = PERSONALIZATION;
var PIPELINE_MANAGEMENT = 'PIPELINE_MANAGEMENT';
exports.PIPELINE_MANAGEMENT = PIPELINE_MANAGEMENT;
var PLATFORM_INTEGRATION = 'PLATFORM_INTEGRATION';
exports.PLATFORM_INTEGRATION = PLATFORM_INTEGRATION;
var PLUGINS = 'PLUGINS';
exports.PLUGINS = PLUGINS;
var POINTS_OF_CONTACT = 'POINTS_OF_CONTACT';
exports.POINTS_OF_CONTACT = POINTS_OF_CONTACT;
var POLLS_VOTING = 'POLLS_VOTING';
exports.POLLS_VOTING = POLLS_VOTING;
var POP_UP_CHAT = 'POP_UP_CHAT';
exports.POP_UP_CHAT = POP_UP_CHAT;
var PORTFOLIO_MANAGEMENT = 'PORTFOLIO_MANAGEMENT';
exports.PORTFOLIO_MANAGEMENT = PORTFOLIO_MANAGEMENT;
var POS = 'POS';
exports.POS = POS;
var POST_SCHEDULING = 'POST_SCHEDULING';
exports.POST_SCHEDULING = POST_SCHEDULING;
var PRE_BUILT_TEMPLATES = 'PRE_BUILT_TEMPLATES';
exports.PRE_BUILT_TEMPLATES = PRE_BUILT_TEMPLATES;
var PREDICTIVE_ANALYTICS = 'PREDICTIVE_ANALYTICS';
exports.PREDICTIVE_ANALYTICS = PREDICTIVE_ANALYTICS;
var PREDICTIVE_DIALER = 'PREDICTIVE_DIALER';
exports.PREDICTIVE_DIALER = PREDICTIVE_DIALER;
var PRESENTATION_MANAGEMENT = 'PRESENTATION_MANAGEMENT';
exports.PRESENTATION_MANAGEMENT = PRESENTATION_MANAGEMENT;
var PRIVACY_OPTIONS = 'PRIVACY_OPTIONS';
exports.PRIVACY_OPTIONS = PRIVACY_OPTIONS;
var PROACTIVE_CHAT = 'PROACTIVE_CHAT';
exports.PROACTIVE_CHAT = PROACTIVE_CHAT;
var PRODUCT_VISUALIZATION = 'PRODUCT_VISUALIZATION';
exports.PRODUCT_VISUALIZATION = PRODUCT_VISUALIZATION;
var PROGRESS_TRACKING = 'PROGRESS_TRACKING';
exports.PROGRESS_TRACKING = PROGRESS_TRACKING;
var PROGRESSIVE_DIALER = 'PROGRESSIVE_DIALER';
exports.PROGRESSIVE_DIALER = PROGRESSIVE_DIALER;
var PROGRESSIVE_PROFILING = 'PROGRESSIVE_PROFILING';
exports.PROGRESSIVE_PROFILING = PROGRESSIVE_PROFILING;
var PROJECT_MANAGEMENT_WITH_BOARDS = 'PROJECT_MANAGEMENT_WITH_BOARDS';
exports.PROJECT_MANAGEMENT_WITH_BOARDS = PROJECT_MANAGEMENT_WITH_BOARDS;
var PROJECT_TAGS_FOLDERS = 'PROJECT_TAGS_FOLDERS';
exports.PROJECT_TAGS_FOLDERS = PROJECT_TAGS_FOLDERS;
var PROJECT_TRACKING = 'PROJECT_TRACKING';
exports.PROJECT_TRACKING = PROJECT_TRACKING;
var PROPOSAL_MANAGEMENT = 'PROPOSAL_MANAGEMENT';
exports.PROPOSAL_MANAGEMENT = PROPOSAL_MANAGEMENT;
var PROSPECTING_TOOLS = 'PROSPECTING_TOOLS';
exports.PROSPECTING_TOOLS = PROSPECTING_TOOLS;
var PUBLIC_PRIVATE = 'PUBLIC_PRIVATE';
exports.PUBLIC_PRIVATE = PUBLIC_PRIVATE;
var PURCHASE_ORDERS = 'PURCHASE_ORDERS';
exports.PURCHASE_ORDERS = PURCHASE_ORDERS;
var PURCHASING = 'PURCHASING';
exports.PURCHASING = PURCHASING;
var Q_A = 'Q_A';
exports.Q_A = Q_A;
var QUESTION_CONDITIONS = 'QUESTION_CONDITIONS';
exports.QUESTION_CONDITIONS = QUESTION_CONDITIONS;
var QUESTION_LIBRARY = 'QUESTION_LIBRARY';
exports.QUESTION_LIBRARY = QUESTION_LIBRARY;
var QUEUE_MANAGEMENT = 'QUEUE_MANAGEMENT';
exports.QUEUE_MANAGEMENT = QUEUE_MANAGEMENT;
var QUEUE_TIMES = 'QUEUE_TIMES';
exports.QUEUE_TIMES = QUEUE_TIMES;
var RANK_TRACKING = 'RANK_TRACKING';
exports.RANK_TRACKING = RANK_TRACKING;
var REAL_TIME_CHAT = 'REAL_TIME_CHAT';
exports.REAL_TIME_CHAT = REAL_TIME_CHAT;
var REAL_TIME_EDITING = 'REAL_TIME_EDITING';
exports.REAL_TIME_EDITING = REAL_TIME_EDITING;
var REAL_TIME_SCHEDULING = 'REAL_TIME_SCHEDULING';
exports.REAL_TIME_SCHEDULING = REAL_TIME_SCHEDULING;
var RECORD_KEEPING = 'RECORD_KEEPING';
exports.RECORD_KEEPING = RECORD_KEEPING;
var RECORDING = 'RECORDING';
exports.RECORDING = RECORDING;
var RECORDING_BOOKMARKING = 'RECORDING_BOOKMARKING';
exports.RECORDING_BOOKMARKING = RECORDING_BOOKMARKING;
var REGISTRATION = 'REGISTRATION';
exports.REGISTRATION = REGISTRATION;
var REGISTRATION_MANAGEMENT = 'REGISTRATION_MANAGEMENT';
exports.REGISTRATION_MANAGEMENT = REGISTRATION_MANAGEMENT;
var REGULATORY_COMPLIANCE = 'REGULATORY_COMPLIANCE';
exports.REGULATORY_COMPLIANCE = REGULATORY_COMPLIANCE;
var REPORTING = 'REPORTING';
exports.REPORTING = REPORTING;
var REPORTING_ANALYTICS = 'REPORTING_ANALYTICS';
exports.REPORTING_ANALYTICS = REPORTING_ANALYTICS;
var REPORTING_DASHBOARDS = 'REPORTING_DASHBOARDS';
exports.REPORTING_DASHBOARDS = REPORTING_DASHBOARDS;
var REPORTING_EVENT_ANALYTICS = 'REPORTING_EVENT_ANALYTICS';
exports.REPORTING_EVENT_ANALYTICS = REPORTING_EVENT_ANALYTICS;
var REPORTS_ANALYTICS = 'REPORTS_ANALYTICS';
exports.REPORTS_ANALYTICS = REPORTS_ANALYTICS;
var REPORTS_DASHBOARDS = 'REPORTS_DASHBOARDS';
exports.REPORTS_DASHBOARDS = REPORTS_DASHBOARDS;
var RESERVED_SEATING = 'RESERVED_SEATING';
exports.RESERVED_SEATING = RESERVED_SEATING;
var RESOURCE_MANAGEMENT = 'RESOURCE_MANAGEMENT';
exports.RESOURCE_MANAGEMENT = RESOURCE_MANAGEMENT;
var RESOURCE_SCHEDULING = 'RESOURCE_SCHEDULING';
exports.RESOURCE_SCHEDULING = RESOURCE_SCHEDULING;
var RESPONSE_AUTOMATION = 'RESPONSE_AUTOMATION';
exports.RESPONSE_AUTOMATION = RESPONSE_AUTOMATION;
var RESPONSE_MANAGEMENT = 'RESPONSE_MANAGEMENT';
exports.RESPONSE_MANAGEMENT = RESPONSE_MANAGEMENT;
var RETURNS_MANAGEMENT = 'RETURNS_MANAGEMENT';
exports.RETURNS_MANAGEMENT = RETURNS_MANAGEMENT;
var REVENUE_MANAGEMENT = 'REVENUE_MANAGEMENT';
exports.REVENUE_MANAGEMENT = REVENUE_MANAGEMENT;
var REVIEWS_MANAGEMENT = 'REVIEWS_MANAGEMENT';
exports.REVIEWS_MANAGEMENT = REVIEWS_MANAGEMENT;
var ROLE_BASED_ACCESS = 'ROLE_BASED_ACCESS';
exports.ROLE_BASED_ACCESS = ROLE_BASED_ACCESS;
var ROLE_BASED_ACCESS_CONTROL = 'ROLE_BASED_ACCESS_CONTROL';
exports.ROLE_BASED_ACCESS_CONTROL = ROLE_BASED_ACCESS_CONTROL;
var ROOM_BOOKING_MANAGEMENT = 'ROOM_BOOKING_MANAGEMENT';
exports.ROOM_BOOKING_MANAGEMENT = ROOM_BOOKING_MANAGEMENT;
var SALES_INTELLIGENCE = 'SALES_INTELLIGENCE';
exports.SALES_INTELLIGENCE = SALES_INTELLIGENCE;
var SALES_MARKETING = 'SALES_MARKETING';
exports.SALES_MARKETING = SALES_MARKETING;
var SCALABILITY = 'SCALABILITY';
exports.SCALABILITY = SCALABILITY;
var SCHEDULED_RECORDING = 'SCHEDULED_RECORDING';
exports.SCHEDULED_RECORDING = SCHEDULED_RECORDING;
var SCREEN_ACTIVITY_RECORDING = 'SCREEN_ACTIVITY_RECORDING';
exports.SCREEN_ACTIVITY_RECORDING = SCREEN_ACTIVITY_RECORDING;
var SCREEN_SHARING = 'SCREEN_SHARING';
exports.SCREEN_SHARING = SCREEN_SHARING;
var SCREENSHARE = 'SCREENSHARE';
exports.SCREENSHARE = SCREENSHARE;
var SEARCH_ENGINE_SUBMISSION = 'SEARCH_ENGINE_SUBMISSION';
exports.SEARCH_ENGINE_SUBMISSION = SEARCH_ENGINE_SUBMISSION;
var SEARCH_FUNCTION = 'SEARCH_FUNCTION';
exports.SEARCH_FUNCTION = SEARCH_FUNCTION;
var SEARCH_MARKETING = 'SEARCH_MARKETING';
exports.SEARCH_MARKETING = SEARCH_MARKETING;
var SEARCHABLE = 'SEARCHABLE';
exports.SEARCHABLE = SEARCHABLE;
var SEASON_TICKETS = 'SEASON_TICKETS';
exports.SEASON_TICKETS = SEASON_TICKETS;
var SECURITY = 'SECURITY';
exports.SECURITY = SECURITY;
var SEGMENTATION = 'SEGMENTATION';
exports.SEGMENTATION = SEGMENTATION;
var SELF_SERVICE_PORTAL = 'SELF_SERVICE_PORTAL';
exports.SELF_SERVICE_PORTAL = SELF_SERVICE_PORTAL;
var SENDING_OUTBOUND_EMAILS = 'SENDING_OUTBOUND_EMAILS';
exports.SENDING_OUTBOUND_EMAILS = SENDING_OUTBOUND_EMAILS;
var SEO = 'SEO';
exports.SEO = SEO;
var SEO_CONTENT_AUTHORING = 'SEO_CONTENT_AUTHORING';
exports.SEO_CONTENT_AUTHORING = SEO_CONTENT_AUTHORING;
var SEO_MANAGEMENT = 'SEO_MANAGEMENT';
exports.SEO_MANAGEMENT = SEO_MANAGEMENT;
var SEO_TOOLS = 'SEO_TOOLS';
exports.SEO_TOOLS = SEO_TOOLS;
var SERVICE_LEVEL_AGREEMENT = 'SERVICE_LEVEL_AGREEMENT';
exports.SERVICE_LEVEL_AGREEMENT = SERVICE_LEVEL_AGREEMENT;
var SESSION_MANAGEMENT = 'SESSION_MANAGEMENT';
exports.SESSION_MANAGEMENT = SESSION_MANAGEMENT;
var SITE_ANALYTICS = 'SITE_ANALYTICS';
exports.SITE_ANALYTICS = SITE_ANALYTICS;
var SITE_INTERCEPT_SURVEY = 'SITE_INTERCEPT_SURVEY';
exports.SITE_INTERCEPT_SURVEY = SITE_INTERCEPT_SURVEY;
var SITE_SELECTION = 'SITE_SELECTION';
exports.SITE_SELECTION = SITE_SELECTION;
var SKIP_LOGIC = 'SKIP_LOGIC';
exports.SKIP_LOGIC = SKIP_LOGIC;
var SLA_STATUS_INDICATORS = 'SLA_STATUS_INDICATORS';
exports.SLA_STATUS_INDICATORS = SLA_STATUS_INDICATORS;
var SLIDESHOW = 'SLIDESHOW';
exports.SLIDESHOW = SLIDESHOW;
var SMART_TRIGGERS = 'SMART_TRIGGERS';
exports.SMART_TRIGGERS = SMART_TRIGGERS;
var SOCIAL_ADS = 'SOCIAL_ADS';
exports.SOCIAL_ADS = SOCIAL_ADS;
var SOCIAL_CAMPAIGNS = 'SOCIAL_CAMPAIGNS';
exports.SOCIAL_CAMPAIGNS = SOCIAL_CAMPAIGNS;
var SOCIAL_ENGAGEMENT = 'SOCIAL_ENGAGEMENT';
exports.SOCIAL_ENGAGEMENT = SOCIAL_ENGAGEMENT;
var SOCIAL_INTEGRATION = 'SOCIAL_INTEGRATION';
exports.SOCIAL_INTEGRATION = SOCIAL_INTEGRATION;
var SOCIAL_MARKETING = 'SOCIAL_MARKETING';
exports.SOCIAL_MARKETING = SOCIAL_MARKETING;
var SOCIAL_MEDIA_INTEGRATION = 'SOCIAL_MEDIA_INTEGRATION';
exports.SOCIAL_MEDIA_INTEGRATION = SOCIAL_MEDIA_INTEGRATION;
var SOCIAL_MEDIA_INTEGRATIONS = 'SOCIAL_MEDIA_INTEGRATIONS';
exports.SOCIAL_MEDIA_INTEGRATIONS = SOCIAL_MEDIA_INTEGRATIONS;
var SOCIAL_MEDIA_MANAGEMENT = 'SOCIAL_MEDIA_MANAGEMENT';
exports.SOCIAL_MEDIA_MANAGEMENT = SOCIAL_MEDIA_MANAGEMENT;
var SOCIAL_MEDIA_MONITORING = 'SOCIAL_MEDIA_MONITORING';
exports.SOCIAL_MEDIA_MONITORING = SOCIAL_MEDIA_MONITORING;
var SOCIAL_MEDIA_PROMOTION = 'SOCIAL_MEDIA_PROMOTION';
exports.SOCIAL_MEDIA_PROMOTION = SOCIAL_MEDIA_PROMOTION;
var SOCIAL_NETWORK_INTEGRATION = 'SOCIAL_NETWORK_INTEGRATION';
exports.SOCIAL_NETWORK_INTEGRATION = SOCIAL_NETWORK_INTEGRATION;
var SOCIAL_NETWORKING = 'SOCIAL_NETWORKING';
exports.SOCIAL_NETWORKING = SOCIAL_NETWORKING;
var SOCIAL_SHARING = 'SOCIAL_SHARING';
exports.SOCIAL_SHARING = SOCIAL_SHARING;
var SOFTWARE_INTEGRATION = 'SOFTWARE_INTEGRATION';
exports.SOFTWARE_INTEGRATION = SOFTWARE_INTEGRATION;
var SOFTWARE_INTEGRATIONS = 'SOFTWARE_INTEGRATIONS';
exports.SOFTWARE_INTEGRATIONS = SOFTWARE_INTEGRATIONS;
var STORAGE_VIEWING_CAPABILITIES = 'STORAGE_VIEWING_CAPABILITIES';
exports.STORAGE_VIEWING_CAPABILITIES = STORAGE_VIEWING_CAPABILITIES;
var STOREFRONT_DESIGN_TOOLS = 'STOREFRONT_DESIGN_TOOLS';
exports.STOREFRONT_DESIGN_TOOLS = STOREFRONT_DESIGN_TOOLS;
var SUBSCRIBE_UNSUBSCRIBE = 'SUBSCRIBE_UNSUBSCRIBE';
exports.SUBSCRIBE_UNSUBSCRIBE = SUBSCRIBE_UNSUBSCRIBE;
var SUPPLIER_PROCUREMENT = 'SUPPLIER_PROCUREMENT';
exports.SUPPLIER_PROCUREMENT = SUPPLIER_PROCUREMENT;
var SUPPLY_CHAIN_MANAGEMENT = 'SUPPLY_CHAIN_MANAGEMENT';
exports.SUPPLY_CHAIN_MANAGEMENT = SUPPLY_CHAIN_MANAGEMENT;
var SURVEY_BUILDER = 'SURVEY_BUILDER';
exports.SURVEY_BUILDER = SURVEY_BUILDER;
var SURVEY_FOR_FEEDBACK = 'SURVEY_FOR_FEEDBACK';
exports.SURVEY_FOR_FEEDBACK = SURVEY_FOR_FEEDBACK;
var SURVEY_TEMPLATE = 'SURVEY_TEMPLATE';
exports.SURVEY_TEMPLATE = SURVEY_TEMPLATE;
var TACTICS = 'TACTICS';
exports.TACTICS = TACTICS;
var TAGGING = 'TAGGING';
exports.TAGGING = TAGGING;
var TARGET_ACCOUNT_IDENTIFICATION = 'TARGET_ACCOUNT_IDENTIFICATION';
exports.TARGET_ACCOUNT_IDENTIFICATION = TARGET_ACCOUNT_IDENTIFICATION;
var TASK_CREATION_ASSIGNMENT = 'TASK_CREATION_ASSIGNMENT';
exports.TASK_CREATION_ASSIGNMENT = TASK_CREATION_ASSIGNMENT;
var TASK_MANAGEMENT = 'TASK_MANAGEMENT';
exports.TASK_MANAGEMENT = TASK_MANAGEMENT;
var TASK_PRIORITIZATION = 'TASK_PRIORITIZATION';
exports.TASK_PRIORITIZATION = TASK_PRIORITIZATION;
var TASK_PROGRESS_TRACKING = 'TASK_PROGRESS_TRACKING';
exports.TASK_PROGRESS_TRACKING = TASK_PROGRESS_TRACKING;
var TAX_CALCS = 'TAX_CALCS';
exports.TAX_CALCS = TAX_CALCS;
var TAX_FILING = 'TAX_FILING';
exports.TAX_FILING = TAX_FILING;
var TAX_MANAGEMENT = 'TAX_MANAGEMENT';
exports.TAX_MANAGEMENT = TAX_MANAGEMENT;
var TEAM_INBOX = 'TEAM_INBOX';
exports.TEAM_INBOX = TEAM_INBOX;
var TEMPLATE_MANAGEMENT = 'TEMPLATE_MANAGEMENT';
exports.TEMPLATE_MANAGEMENT = TEMPLATE_MANAGEMENT;
var TEMPLATES = 'TEMPLATES';
exports.TEMPLATES = TEMPLATES;
var TERRITORY_MANAGEMENT = 'TERRITORY_MANAGEMENT';
exports.TERRITORY_MANAGEMENT = TERRITORY_MANAGEMENT;
var THIRD_PARTY_INTEGRATION = 'THIRD_PARTY_INTEGRATION';
exports.THIRD_PARTY_INTEGRATION = THIRD_PARTY_INTEGRATION;
var THIRD_PARTY_INTEGRATIONS = 'THIRD_PARTY_INTEGRATIONS';
exports.THIRD_PARTY_INTEGRATIONS = THIRD_PARTY_INTEGRATIONS;
var THIRD_PARTY_STORE_INTEGRATION = 'THIRD_PARTY_STORE_INTEGRATION';
exports.THIRD_PARTY_STORE_INTEGRATION = THIRD_PARTY_STORE_INTEGRATION;
var THREE_PANE_PROJECT_VIEW = 'THREE_PANE_PROJECT_VIEW';
exports.THREE_PANE_PROJECT_VIEW = THREE_PANE_PROJECT_VIEW;
var TICKET_BROKERING = 'TICKET_BROKERING';
exports.TICKET_BROKERING = TICKET_BROKERING;
var TICKET_COLLABORATION = 'TICKET_COLLABORATION';
exports.TICKET_COLLABORATION = TICKET_COLLABORATION;
var TICKET_ISSUE_TRACKING = 'TICKET_ISSUE_TRACKING';
exports.TICKET_ISSUE_TRACKING = TICKET_ISSUE_TRACKING;
var TICKETING = 'TICKETING';
exports.TICKETING = TICKETING;
var TIME_ATTENDENCE_TRACKING = 'TIME_ATTENDENCE_TRACKING';
exports.TIME_ATTENDENCE_TRACKING = TIME_ATTENDENCE_TRACKING;
var TIME_TRACKING_INTEGRATION = 'TIME_TRACKING_INTEGRATION';
exports.TIME_TRACKING_INTEGRATION = TIME_TRACKING_INTEGRATION;
var TO_DO_LISTS = 'TO_DO_LISTS';
exports.TO_DO_LISTS = TO_DO_LISTS;
var TRAINING_MANAGEMENT = 'TRAINING_MANAGEMENT';
exports.TRAINING_MANAGEMENT = TRAINING_MANAGEMENT;
var TRANSFERS_ROUTING = 'TRANSFERS_ROUTING';
exports.TRANSFERS_ROUTING = TRANSFERS_ROUTING;
var UNIFIED_CUSTOMER_EXPERIENCE = 'UNIFIED_CUSTOMER_EXPERIENCE';
exports.UNIFIED_CUSTOMER_EXPERIENCE = UNIFIED_CUSTOMER_EXPERIENCE;
var UPDATES = 'UPDATES';
exports.UPDATES = UPDATES;
var UPLOAD = 'UPLOAD';
exports.UPLOAD = UPLOAD;
var URL_BUILDER = 'URL_BUILDER';
exports.URL_BUILDER = URL_BUILDER;
var USER_MANAGEMENT = 'USER_MANAGEMENT';
exports.USER_MANAGEMENT = USER_MANAGEMENT;
var USER_PERMISSIONS = 'USER_PERMISSIONS';
exports.USER_PERMISSIONS = USER_PERMISSIONS;
var USER_REGISTRATION_PROCESS = 'USER_REGISTRATION_PROCESS';
exports.USER_REGISTRATION_PROCESS = USER_REGISTRATION_PROCESS;
var USER_ROLE_ACCESS_MANAGEMENT = 'USER_ROLE_ACCESS_MANAGEMENT';
exports.USER_ROLE_ACCESS_MANAGEMENT = USER_ROLE_ACCESS_MANAGEMENT;
var UTILITIES = 'UTILITIES';
exports.UTILITIES = UTILITIES;
var VENUE_MANAGEMENT = 'VENUE_MANAGEMENT';
exports.VENUE_MANAGEMENT = VENUE_MANAGEMENT;
var VERSION_CONTROL = 'VERSION_CONTROL';
exports.VERSION_CONTROL = VERSION_CONTROL;
var VIDEO_CALL_RECORDING = 'VIDEO_CALL_RECORDING';
exports.VIDEO_CALL_RECORDING = VIDEO_CALL_RECORDING;
var VIDEO_HOSTING = 'VIDEO_HOSTING';
exports.VIDEO_HOSTING = VIDEO_HOSTING;
var VIDEO_LOOPING = 'VIDEO_LOOPING';
exports.VIDEO_LOOPING = VIDEO_LOOPING;
var VIDEO_STREAMING = 'VIDEO_STREAMING';
exports.VIDEO_STREAMING = VIDEO_STREAMING;
var VIEWS_DASHBOARDS_REPORTS = 'VIEWS_DASHBOARDS_REPORTS';
exports.VIEWS_DASHBOARDS_REPORTS = VIEWS_DASHBOARDS_REPORTS;
var VIP_DISCOUNT_TICKETS = 'VIP_DISCOUNT_TICKETS';
exports.VIP_DISCOUNT_TICKETS = VIP_DISCOUNT_TICKETS;
var VISITOR_IDENTIFICATION = 'VISITOR_IDENTIFICATION';
exports.VISITOR_IDENTIFICATION = VISITOR_IDENTIFICATION;
var VOICEMAIL_AND_NOTIFICATIONS = 'VOICEMAIL_AND_NOTIFICATIONS';
exports.VOICEMAIL_AND_NOTIFICATIONS = VOICEMAIL_AND_NOTIFICATIONS;
var W3C_COMPLIANCE = 'W3C_COMPLIANCE';
exports.W3C_COMPLIANCE = W3C_COMPLIANCE;
var WEB_PORTAL = 'WEB_PORTAL';
exports.WEB_PORTAL = WEB_PORTAL;
var WEB_SERVICES = 'WEB_SERVICES';
exports.WEB_SERVICES = WEB_SERVICES;
var WEB_TRAFFIC_ANALYTICS = 'WEB_TRAFFIC_ANALYTICS';
exports.WEB_TRAFFIC_ANALYTICS = WEB_TRAFFIC_ANALYTICS;
var WEBSITE_ANALYTICS_INTEGRATION = 'WEBSITE_ANALYTICS_INTEGRATION';
exports.WEBSITE_ANALYTICS_INTEGRATION = WEBSITE_ANALYTICS_INTEGRATION;
var WEBSITE_BUILDER = 'WEBSITE_BUILDER';
exports.WEBSITE_BUILDER = WEBSITE_BUILDER;
var WEBSITE_VISITOR_TRACKING = 'WEBSITE_VISITOR_TRACKING';
exports.WEBSITE_VISITOR_TRACKING = WEBSITE_VISITOR_TRACKING;
var WHISPER_COACHING = 'WHISPER_COACHING';
exports.WHISPER_COACHING = WHISPER_COACHING;
var WHITE_LABELING = 'WHITE_LABELING';
exports.WHITE_LABELING = WHITE_LABELING;
var WIDGETS = 'WIDGETS';
exports.WIDGETS = WIDGETS;
var WORD_PROCESSOR = 'WORD_PROCESSOR';
exports.WORD_PROCESSOR = WORD_PROCESSOR;
var WORKFLOW_AUTOMATION = 'WORKFLOW_AUTOMATION';
exports.WORKFLOW_AUTOMATION = WORKFLOW_AUTOMATION;
var WORKFLOW_CONFIGURATION = 'WORKFLOW_CONFIGURATION';
exports.WORKFLOW_CONFIGURATION = WORKFLOW_CONFIGURATION;
var WYSIWYG_FORM_DESIGNER = 'WYSIWYG_FORM_DESIGNER';
exports.WYSIWYG_FORM_DESIGNER = WYSIWYG_FORM_DESIGNER;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/CategoryFeature.js
// module id = 20
// module chunks = 209 210 211 212 213